import React from 'react';
import aboutImg from '../../../images/Browsing-online-bro.png';
import './AboutMe.css';

const AboutMe = () => {
    return (
        <section className="about">
            <div className="container">
                <div className="row">
                    <div style={{overflow: 'hidden'}} className="col-md-6 aboutImg" data-aos="zoom-in" data-aos-duration="1000">
                        <img src={aboutImg} alt="" />
                    </div>
                    <div style={{overflow: 'hidden'}} className="col-md-6 text-white gap" data-aos="zoom-in" data-aos-duration="1000">
                        <h2>About me</h2>
                        <br />
                        <p className="text-justify">
                            I am a quick learner. I believe in hard work
                            and efficiency. I always like to learn new
                            things and have experience with new stuff.
                            Dedicated, energetic, and motivated team
                            player seeking a career that would enable me
                            to utilize into the Web developing field.
                        </p>
                        <br />

                        <div className="tag">
                            <ul>
                                <li><span>JavaScript</span></li>
                                <li><span>React.js</span></li>
                                <li><span>Redux</span></li>
                                <li><span>Bootstrap</span></li>
                                <li><span>Material Ui</span></li>
                                <li><span>Tailwind-CSS</span></li>
                                <li><span>React Native</span></li>
                                <li><span>Node.js</span></li>
                                <li><span>Express.js</span></li>
                                <li><span>MongoDB</span></li>
                            </ul>
                        </div><br />
                        <div className='resume-btn'>
                            <a href="https://drive.google.com/uc?export=download&amp;id=1R98QtDc2Ugrpi1adkBoSc13PGRqNccO1" className="btn btn-danger">Download Resume&nbsp;<i class="fa fa-arrow-down"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutMe;